<template>
  <FhDialog ref="dialogRef" size="md" @update:is-open="onOpenChange">
    <template #title>
      <span data-test-id="fh-waiver-modal-title">
        {{ computedOpenModalTitleText }}
      </span>
    </template>

    <template #content>
      <FhRichText :markdown="props.companyTerms" />
    </template>
  </FhDialog>
</template>

<script setup>
import { computed, onUpdated, ref } from 'vue';
import { FhDialog, FhRichText } from '@fareharbor-com/beacon-vue';
import { track } from '../../scripts/mixpanel';

const emit = defineEmits(['close']);

const props = defineProps({
  companyName: {
    type: String,
    default: '',
  },
  companyTerms: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const dialogRef = ref(null);

onUpdated(() => {
  if (props.isOpen) {
    dialogRef.value.open();

    track('click-fh-waiver-view-client-policy');
  }
});

const computedOpenModalTitleText = computed(() =>
  interpolate(T('%(name)s Policies and Terms'), {
    name: props.companyName,
  }),
);

const onOpenChange = (isOpen) => {
  if (!isOpen) {
    emit('close');
  }
};
</script>

<style scoped>
.view-policies-button {
  font-size: var(--fh-typography-font-size-50);
}
</style>
